import { __generator } from "tslib";
import i18next from 'i18next';
import { all, take, call, put, takeEvery } from 'redux-saga/effects';
import { request } from '../../../xhr';
import { actions as modalActions } from '../../../Modals';
import { ModalType } from '../../../Modals/redux/types';
import { reduxModuleLoaded, createTipJarTier } from './actions';
function handleCreateTipJarTier() {
    var data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    title: i18next.t('tierPopup.tipJar.title'),
                    description: i18next.t('tierPopup.tipJar.description'),
                    price: 2,
                    display_num_subscribers: false,
                    benefits: [
                        i18next.t('tierPopup.tipJar.firstBenefit'),
                        i18next.t('tierPopup.tipJar.secondBenefit'),
                    ],
                    tags: ['tipjar', 'tip'],
                    access_settings: 'all',
                    thank_message_title: i18next.t('tierPopup.tipJar.thanks.title'),
                    thank_message_body: i18next.t('tierPopup.tipJar.thanks.body'),
                    cover_image_deviation_id: 902857689,
                    is_mature: false,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/tier/create',
                        data: data,
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, put(modalActions.pushModal(ModalType.TIER_EDIT, {
                        wrapInModal: false,
                        params: response,
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function userTiersSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(reduxModuleLoaded)];
            case 1:
                _a.sent();
                return [4 /*yield*/, all([takeEvery(createTipJarTier, handleCreateTipJarTier)])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=tipJarSaga.js.map